export const AppConfig = {
	myLoggerColors: {
		trace: 'gray',
		log: 'gray',
		info: '#cce5ff',
		error: '#f8d7da',
		debug: '#fff3cd',
	},
	// TODO wrapp routes to object
	routes: {
		auth: {
			path: 'auth',
			signIn: {
				fullPath: '/auth/sign-in/choose-method',
				path: 'sign-in',
				title: 'sign-in',
				chooseMethod: {
					fullPath: '/auth/sign-in/choose-method',
					path: 'choose-method',
					title: 'choose-method',
				},
				signInManually: {
					fullPath: '/auth/sign-in/manually',
					path: 'manually',
					title: 'manually',
				}
			},
			welcome: {
				fullPath: 'auth/welcome',
				path: 'welcome',
				title: 'Welcome'
			},
			signUp: {
				fullPath: '/auth/sign-up/choose-method',
				path: 'sign-up',
				title: 'sign-up',
				chooseMethod: {
					fullPath: '/auth/sign-up/choose-method',
					path: 'choose-method',
					title: 'choose-method',
				},

				signUpManually: {
					fullPath: '/auth/sign-up/manually',
					path: 'manually',
					title: 'manually',
				}
			},
			forgotPassword: {
				fullPath: '/auth/forgot-password',
				path: 'forgot-password',
				title: 'Forgot password'
			},

			resetPassword: {
				fullPath: '/auth/reset-password',
				path: 'reset-password',
				title: 'Reset password'
			},

			changePassword: {
				fullPath: '/auth/change-password',
				path: 'change-password',
				title: 'Change password'
			},

			verification: {
				fullPath: '/auth/verification',
				path: 'verification',
				title: 'Email verification'
			},
			greeting: {
				fullPath: '/auth/greeting',
				path: 'greeting',
				title: 'Greeting'
			},
			unsubscribe: {
				fullPath: 'emails',
				path: 'emails',
				title: 'Emails'
			}
		},

		home: {
			fullPath: '/home',
			path: 'home',
			title: 'Home'
		},
		account: {
			fullPath: '/account',
			path: 'account',
			title: 'My Account'
		},
		newsDetails: {
			fullPath: 'news-details',
			path: 'news-details',
			title: 'news-details'
		},
		settings: {
			fullPath: '/settings',
			path: 'settings',
			title: 'menu.profile'
		},
		support: {
			fullPath: '/support',
			path: 'support',
			title: 'menu.support'
		},
		profile: {
			fullPath: 'profile',
			path: 'profile',
			title: 'Profile',

			personalInfo: {
				fullPath: 'profile/personal-info',
				path: 'personal-info',
				title: 'Personal Info',
			},

			address: {
				fullPath: 'profile/address',
				path: 'address',
				title: 'Address',
			},
			paymentMethods: {
				fullPath: 'profile/my-payment-methods',
				path: 'my-payment-methods',
				title: 'My Payment Methods',
			},

			myFreeHours: {
				fullPath: 'profile/my-free-hours',
				path: 'my-free-hours',
				title: 'my-free-hours',
			},

			choosePaymentMethods: {
				fullPath: 'profile/choose-payment-methods',
				path: 'choose-payment-methods',
				title: 'choose-payment-methods',
			},

			addNewPaymentMethod: {
				fullPath: 'profile/add-new-payment-method',
				path: 'add-new-payment-method',
				title: 'add-new-payment-method',
			},
			paypalPayment: {
				fullPath: 'profile/payment-paypal',
				path: 'payment-paypal',
				title: 'payment-paypal',
			},

			giropayPage: {
				fullPath: 'profile/payment-giropay',
				path: 'payment-giropay',
				title: 'payment-giropay',
			},
			notificationsPage: {
				fullPath: 'profile/notifications',
				path: 'notifications',
				title: 'notifications',
			},
			notificationsSettingsPage: {
				fullPath: 'profile/notifications-settings',
				path: 'notifications-settings',
				title: 'notifications-settings',
			},
			termsAndPrivacy: {
				fullPath: 'profile/terms-and-privacy',
				path: 'terms-and-privacy',
				title: 'terms-and-privacy',
			},
			promotions: {
				fullPath: 'profile/promotions',
				path: 'promotions',
				title: 'Promotions',
			},
			referralProgram: {
				fullPath: 'profile/referral-program',
				path: 'referral-program',
				title: 'referral-program',
			},
		},
		facilities: {
			path: 'facilities',
			map: {
				fullPath: 'facilities/map',
				path: 'map',
				title: '',
			},
			list: {
				fullPath: 'facilities/list',
				path: 'list',
				title: '',
			},
		},

		publicFacilities: {
			path: 'facilities',
			map: {
				fullPath: 'facilities/map/public',
				path: 'map',
				title: '',
			},
			list: {
				fullPath: 'facilities/list/public',
				path: 'list',
				title: '',
			},
		},

		info: {
			path: 'info',
			faq: {
				fullPath: 'info/faq',
				path: 'faq',
				title: 'FAQ'
			},
			contactUs: {
				fullPath: 'info/contact-us',
				path: 'contact-us',
				title: 'Contact Us'
			},
			userGuide: {
				fullPath: 'info/user-guide',
				path: 'user-guide',
				title: 'User Guide'
			},
			about: {
				fullPath: 'info/about',
				path: 'about',
				title: 'About'
			},
		},

		payments: {
			path: 'payment',
			payment: {
				fullPath: 'payment',
				path: 'payment',
				title: 'Payment'
			},

			paymentHistory: {
				fullPath: 'payment/history',
				path: 'history',
				title: 'Payment History'
			},
		},

		sharedBookings: {
			path: 'shared-bookings-access',
			sharedBookingsList: {
				fullPath: 'shared-bookings-access/list',
				path: 'list',
				title: 'Shared Bookings List'
			},
			addSharedBookings: {
				fullPath: 'shared-bookings-access/add',
				path: 'add',
				title: 'Add Shared Booking'
			},

			editSharedBookings: {
				fullPath: 'shared-bookings-access/edit',
				path: 'edit',
				title: 'Add Shared Booking'
			},
			sharedBookingSuccess: {
				fullPath: 'shared-bookings-access/success',
				path: 'success',
				title: 'Shared Booking Success'
			},

			sharedBookingLogs: {
				fullPath: 'shared-bookings-access/logs',
				path: 'logs',
				title: 'Shared Booking Logs'
			}
		},
		chat: {
			fullPath: 'chat',
			path: 'chat',
			title: 'Chat'
		},
		claims: {
			fullPath: 'claims',
			path: 'claims',
			title: 'Claims'
		},
		marketplace: {
			fullPath: '/marketplace',
			path: '/marketplace',
			title: 'Marketplace',
		},
		productDetails: {
			fullPath: 'marketplace/product-details',
			path: '/product-details',
			title: 'Product Details',
		},
		shoppingCart: {
			fullPath: 'marketplace/shopping-cart',
			path: '/shopping-cart',
			title: 'Shopping Cart',
		},
		purchaseConfirmation: {
			fullPath: 'purchase-confirmation',
			path: '/purchase-confirmation',
			title: 'Purchase Confirmation',
		},
		purchases: {
			fullPath: '/purchases',
			path: '/purchases',
			title: 'Purchases',
		},
		orderDetails: {
			fullPath: 'order-details',
			path: '/order-details',
			title: 'Order Details',
		}
	}
};
